import gql from 'graphql-tag';

export const printProductSizeBaseInfo = gql`
  query getPrintProductSizeBaseInfo(
    $print_product_id: RecordID!
    $print_product_size_id: RecordID!
  ) {
    printProducts(print_product_id: $print_product_id) {
      total
      records {
        id
        sizes(print_product_size_id: $print_product_size_id) {
          total
          records {
            id
            orientations
            print_size {
              id
              name
            }
            total_price {
              value
              currency
            }
          }
        }
      }
    }
  }
`;
